import kr from 'Kr/kr';
import Macy from 'macy';

export default class Mansory extends kr.Component {
    init() {
        this.mansory = new Macy({
            container: this.$element,
            trueOrder: true,
            waitForImages: false,
            useOwnImageLoader: false,
            debug: false,
            mobileFirst: true,
            columns: 1,
            margin: {
                y: 15,
                x: 15,
            },
            breakAt: {
                1200: 4,
                940: 3,
                520: 2,
                400: 1
            },
        });
    }
}

kr.registerComponent('.js_mansory', {
    component: Mansory
});